export function safeJsonStringify(obj) {
    const cache = new Set();
    try {
        return JSON.stringify(obj, (_, value) => {
            if (typeof value === 'object' && value !== null) {
                if (cache.has(value)) {
                    return '[Circular]';
                }
                cache.add(value);
            }
            return value;
        }, 2);
    }
    catch {
        return '';
    }
}
